import { TRANSCRIBER_DASHBOARD } from "../settings";

export function redirectToTranscriberDashboard() {
  window.location.href = TRANSCRIBER_DASHBOARD;
}
